/** Central testid constants for CollectOne. */
export const T = {
  // auth
  signupForm: "signup-form",
  signupEmail: "signup-email-input",
  signupPassword: "signup-password-input",
  signupName: "signup-name-input",
  signupBiz: "signup-business-name-input",
  signupType: "signup-business-type-select",
  signupSubmit: "signup-submit-button",
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",
  logoutButton: "logout-button",

  // layout
  sidebar: "app-sidebar",
  navDashboard: "nav-dashboard",
  navClients: "nav-clients",
  navPaymentOptions: "nav-payment-options",
  navReminderRules: "nav-reminder-rules",
  navReminders: "nav-reminders",
  navSettings: "nav-settings",

  // dashboard
  kpiTotalClients: "kpi-total-clients",
  kpiOverdue: "kpi-overdue",
  kpiUpcoming: "kpi-upcoming",
  kpiPendingAmount: "kpi-pending-amount",
  kpiCollectedMonth: "kpi-collected-month",
  chartCollections: "chart-collections",
  triggerSweepBtn: "trigger-sweep-button",

  // clients
  addClientBtn: "add-client-button",
  bulkUploadBtn: "bulk-upload-button",
  csvTemplateBtn: "csv-template-button",
  csvFileInput: "csv-file-input",
  importReportDialog: "import-report-dialog",
  importReportRow: "import-report-row",
  importDownloadFailed: "import-download-failed",
  importClose: "import-close-button",
  clientRow: "client-row",
  clientSearch: "client-search-input",
  clientStatusFilter: "client-status-filter",
  clientFormName: "client-form-name",
  clientFormPhone: "client-form-phone",
  clientFormEmail: "client-form-email",
  clientFormProduct: "client-form-product",
  clientFormAmount: "client-form-amount",
  clientFormCycle: "client-form-cycle",
  clientFormDue: "client-form-due",
  clientFormNotes: "client-form-notes",
  clientFormSubmit: "client-form-submit",
  markPaidBtn: "mark-paid-button",
  sendReminderBtn: "send-reminder-button",
  deleteClientBtn: "delete-client-button",

  // payment options
  addOptionBtn: "add-payment-option-button",
  optionTypeSelect: "payment-option-type-select",
  optionLabel: "payment-option-label",
  optionUpiId: "payment-option-upi-id",
  optionUrl: "payment-option-url",
  optionDirectory: "payment-option-directory-select",
  optionSubmit: "payment-option-submit",

  // reminder rules
  ruleDays: "rule-days-input",
  ruleChannels: "rule-channels",
  ruleTemplate: "rule-template",
  ruleSave: "rule-save-button",

  // settings
  wsName: "workspace-name-input",
  wsType: "workspace-type-select",
  wsSave: "workspace-save-button",
  // team
  navTeam: "nav-team",
  teamInviteBtn: "team-invite-button",
  teamInviteEmail: "team-invite-email",
  teamInviteRole: "team-invite-role",
  teamInviteSubmit: "team-invite-submit",
  teamCopyLink: "team-copy-invite-link",
  teamMemberRow: "team-member-row",

  // accept invite
  acceptName: "accept-invite-name",
  acceptPassword: "accept-invite-password",
  acceptSubmit: "accept-invite-submit",

  // clients segments + portal
  clientSegmentInput: "client-segment-input",
  clientSegmentFilter: "client-segment-filter",
  copyPortalLink: "copy-portal-link",

  // reminder rules (multi)
  addRuleBtn: "add-rule-button",
  ruleNameInput: "rule-name-input",
  ruleSegmentFilter: "rule-segment-filter",
  ruleDeleteBtn: "rule-delete-button",

  // settings
  wsWhatsappMode: "workspace-whatsapp-mode",
  wsWhatsappNumber: "workspace-whatsapp-number",

  // reminder log
  openWhatsappBtn: "open-whatsapp-button",

  // verify queue
  navVerify: "nav-verify",
  verifyQueueRow: "verify-queue-row",

  // portal (public)
  portalPayLink: "portal-pay-link",
  portalConfirmBtn: "portal-confirm-paid-button",
  portalReference: "portal-payment-reference",
  portalConfirmSubmit: "portal-confirm-submit",
  portalReceiptInput: "portal-receipt-input",
  portalLangSwitcher: "portal-lang-switcher",
  portalLangOption: "portal-lang",
  portalThankYou: "portal-thank-you",
  portalReportAnother: "portal-report-another",

  // template picker
  templatePicker: "rule-template-picker",
  templateOption: "rule-template-option",

  // verify queue
  verifyPaymentBtn: "verify-payment-button",
  rejectPaymentBtn: "reject-payment-button",
  viewReceiptBtn: "view-receipt-button",

  // platform admin console
  platformWsRow: "platform-ws-row",
  platformSuspendBtn: "platform-suspend",
  platformUnsuspendBtn: "platform-unsuspend",
  platformDeleteBtn: "platform-delete",

  // platform nav
  navPlatformWs: "nav-platform-workspaces",
  navPlatformUsers: "nav-platform-users",

  // ageing report
  navAgeing: "nav-ageing",
  ageingBucket: "ageing-bucket",
  ageingClientRow: "ageing-client-row",
  ageingCsvBtn: "ageing-download-csv",

  // portal snooze
  portalSnoozeBtn: "portal-snooze-button",
  portalSnoozeStatus: "portal-snooze-status",

  // razorpay credentials fields (per-workspace)
  rzpKeyIdInput: "rzp-key-id-input",
  rzpKeySecretInput: "rzp-key-secret-input",
  rzpWebhookSecretInput: "rzp-webhook-secret-input",
  rzpWebhookUrlCopy: "rzp-webhook-url-copy",

  // business signature (settings)
  wsContactPersonName: "workspace-contact-person-name",
  wsContactPhone: "workspace-contact-phone",
  wsContactEmail: "workspace-contact-email",
  wsWebsite: "workspace-website",

  // per-client payment option mapping
  clientPaymentOptionCheckbox: "client-payment-option-checkbox",
  clientMappedOption: "client-mapped-option",

  // SMS templates (copy & send)
  navSmsTemplates: "nav-sms-templates",
  smsTemplateCard: "sms-template-card",
  smsClientPicker: "sms-client-picker",
  smsRenderedText: "sms-rendered-text",
  smsCopyBtn: "sms-copy-button",
  smsOpenBtn: "sms-open-native-button",
  smsQuickCopyBtn: "sms-quick-copy-button",
  smsTemplateDialog: "sms-template-dialog",

  // WhatsApp quick-send + payment option quick picker (client row)
  whatsappQuickBtn: "whatsapp-quick-send-button",
  paymentOptionsQuickBtn: "payment-options-quick-picker-button",
  paymentOptionsPickerDialog: "payment-options-picker-dialog",
  paymentOptionsQuickCheckbox: "payment-options-quick-checkbox",
  paymentOptionsQuickSave: "payment-options-quick-save",

  // WhatsApp Inbox
  navWhatsapp: "nav-whatsapp",
  waWizardSave: "wa-wizard-save",
  waTokenInput: "wa-token-input",
  waPhoneIdInput: "wa-phone-id-input",
  waWabaIdInput: "wa-waba-id-input",
  waAppSecretInput: "wa-app-secret-input",
  waRegenerateBtn: "wa-regenerate-verify-btn",
  waSelfTestBtn: "wa-self-test-webhook-btn",
  waConversationItem: "wa-conversation-item",
  waMessageInput: "wa-message-input",
  waSendBtn: "wa-send-button",
};
